<template>
  <ProductPricePage
    :product="data.product"
    :product-data="data.productData"
    :subscription="subscription"
  >
    <NuxtPage
      :product="data.product"
      :product-data="data.productData"
      :subscription="subscription"
    />
  </ProductPricePage>
</template>

<script setup lang="ts">
import {
  ANODE,
  MARKET,
  SUBSCRIPTION_PRICE_ASSESSMENTS_ANODE,
} from '~/constants/services/constants'
import anodeData from '~/constants/price-assessments/unauthorized/anode'
import ProductPricePage from '~/components/market/ProductPricePage.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ layout: 'services' })

const subscription = SUBSCRIPTION_PRICE_ASSESSMENTS_ANODE
const data = {
  product: ANODE,
  productData: anodeData,
  subscription,
}

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${ANODE.name} Prices`,
})
useHead(seo)
</script>
